// @flow

import FontFaceObserver from "fontfaceobserver"

const Fonts = async () => {
  const link = document.createElement("link")

  link.href =
    "https://fonts.googleapis.com/css?family=Nunito+Sans:300,400,600,700,800"
  link.rel = "stylesheet"

  if (!document.head) return

  document.head.appendChild(link)

  try {
    const font = new FontFaceObserver("Nunito Sans")

    // 1 minute timeout
    await font.load(null, 60 * 1000)
  } catch (e) {
    // No need to handle.
  }
}

export default Fonts
